import base64 from 'base-64'
import fetch from 'isomorphic-fetch'
import SecureLS from 'secure-ls'
import { CLIENT_ID, ENDPOINT, SECRET } from '../settings'

const storage = new SecureLS({
  encodingType: 'aes',
  isCompression: true,
  encryptionSecret: SECRET
})

let ACCESS_TOKEN = null
let REFRESH_TOKEN = null

export default {
  getAccessToken () {
    return ACCESS_TOKEN
  },

  getRefreshToken () {
    return REFRESH_TOKEN
  },

  setToken (data) {
    ACCESS_TOKEN = data.access_token
    REFRESH_TOKEN = data.refresh_token
  },

  logout () {
    storage.clear()
    ACCESS_TOKEN = null
    REFRESH_TOKEN = null
  },

  attemptAutoLogin () {
    const username = storage.get('username')
    const password = storage.get('password')

    if (typeof username !== 'string' || typeof password !== 'string' || username.trim() === '' || password.trim() === '') {
      return Promise.reject(new Error('No username/password stored'))
    }

    console.log(`[oauth#attemptAutoLogin] logging in with username ${username} and password ${password}`)
    return this
      .login(username, password, true)
      .catch(err => {
        console.warn(`[oauth#attemptAutoLogin] clearing credentials; error logging in: ${err.message}`)
        storage.clear()
      })
  },

  login (username, password, remember) {
    return fetch(`${ENDPOINT}/oauth/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${base64.encode(`${username}:${password}`)}`
      },
      body: JSON.stringify({
        username: `${username}`,
        password,
        scope: CLIENT_ID,
        client_id: CLIENT_ID,
        grant_type: 'password'
      })
    })
      .then(response => {
        if (!response.ok || response.status !== 200) {
          throw new Error(response.statusText || 'An error occurred')
        }

        if (remember === true) {
          storage.set('username', username)
          storage.set('password', password)
        }

        return response.json()
      })
      .then(data => {
        this.setToken(data)
        return data
      })
  },

  me () {
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getAccessToken()}`
      }
    }

    return fetch(`${ENDPOINT}/api/v1/me`, options)
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Invalid status code ${response.status}`)
        }
        return response.json()
      })
      .catch(err => {
        console.log(`[OAuth] ${err.message}`)
      })
  }
}



// WEBPACK FOOTER //
// ./lib/oauth.js